import React, { useEffect, useState, useMemo } from 'react';
import Step1 from './step1';
import StepHome from './step_home';
import { Step1WithEmailLandingIntroduction, Step1WithReferralIntroduction } from './step1';
import Step3 from './step3';
import { useDispatch } from 'react-redux';
import { actions as demoRequestActions } from '../../actions/demoRequest';
// const StepList = [Step1, Step3];

const GetADemoGuide = ({ forEmailLanding = false, showSkipNow = false, onSkip, onAfterSubmit, title, subTitle }) => {
  const [step, setStep] = useState(0);
  const dispatch = useDispatch();
  const prevStep = () => {
    setStep((prev) => prev - 1);
  };

  const nextStep = () => {
    if (onAfterSubmit) {
      onAfterSubmit && onAfterSubmit();
    } else {
      setStep((prev) => prev + 1);
    }
  };

  useEffect(() => {
    dispatch({
      type: demoRequestActions.reset,
    });
  }, []);

  const StepList = useMemo(() => {
    if (forEmailLanding) {
      return [Step1WithEmailLandingIntroduction, Step3];
    }
    return [Step1, Step3];
  }, [forEmailLanding]);

  return <div>{React.createElement(StepList[step], { showSkipNow, prevStep, nextStep, onSkip, title, subTitle })}</div>;
};

export default GetADemoGuide;

export const ReferralGuide = ({ onSkip, onAfterSubmit, title, subTitle }) => {
  const [step, setStep] = useState(0);
  const dispatch = useDispatch();
  const prevStep = () => {
    setStep((prev) => prev - 1);
  };

  const nextStep = () => {
    if (onAfterSubmit) {
      onAfterSubmit && onAfterSubmit();
    } else {
      setStep((prev) => prev + 1);
    }
  };

  useEffect(() => {
    dispatch({
      type: demoRequestActions.reset,
    });
  }, []);

  return (
    <div style={{ backgroundColor: '#fffffff' }}>
      {React.createElement(Step1WithReferralIntroduction, { prevStep, nextStep, onSkip, title, subTitle })}
    </div>
  );
};

export const HomeGetADemoGuide = ({
  forEmailLanding = false,
  showSkipNow = false,
  onSkip,
  onAfterSubmit,
  title,
  subTitle,
}) => {
  const [step, setStep] = useState(0);
  const dispatch = useDispatch();

  const nextStep = () => {
    if (onAfterSubmit) {
      onAfterSubmit && onAfterSubmit();
    } else {
      setStep((prev) => prev + 1);
    }
  };

  useEffect(() => {
    dispatch({
      type: demoRequestActions.reset,
    });
  }, []);

  return (
    <div>
      {React.createElement(StepHome, { showSkipNow: false, prevStep: () => {}, nextStep, onSkip, title, subTitle })}
    </div>
  );
};
